import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const UnnaturalTestimony: Portfolio = {
    path: "unnatural-testimony", name: "Unnatural Testimony", pageStyle: PageStyle.Tan, pieces: [
        {
            image: "unnatural-testimony-01.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 1",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-02.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 2",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-03.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 3",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-04.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 4",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-05.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 5",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-06.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 6",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-17.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 17",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-29.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 29",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-19.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 19",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "unnatural-testimony-33.jpg",
            thumbAlt: "Unnatural Testimony",
            title: "Unnatural Testimony 33",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
    ],
    piecesColumns: 5,
    statement: {
        leftColumn: [
            "I have been exploring resilience in our natural world during challenging times for many years. From the oceans to the plains to remote caves, there is a story of regeneration. The underlying complex systems that provide the context in which we live, endure and even thrive in unusual and remarkable ways.",
            "My most recent exploration deals with the uncanny survival of plant life in the Chernobyl 30 km exclusion zone since the 1986 nuclear accident. \"Unnatural Testimony\" is a series of prints that reflect my interpretation and reaction to a set of haunting images (taken as photograms by Anais Tondeur) of the flora around Chernobyl."
        ],
        rightColumn: [
            "These plants are suspended in the time of the accident and have not died. Core cells have been transformed, invisible to the naked eye. The images are mysterious, haunting, still shots with wayward tendrils and disrupted elements to suggest unexpected and unusual behavior over time in reaction to the radiation.",
            "The vegetation in the shadow of Chernobyl heralds both promise and peril and provides \"unnatural testimony,\" having endured nuclear catastrophe for decades.",
            "Erika Radich\n" +
            "October 2017"
        ]
    }
};

export default UnnaturalTestimony;